import styled, { css } from 'styled-components';
import { margin, MarginProps, padding, PaddingProps } from 'styled-system';

export const Summary = styled.div<PaddingProps & MarginProps>`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.gray.extraLight};
  `};
  box-sizing: border-box;
  border-radius: 8px;
  ${margin};
  ${padding};
`;
